module.exports = __webpack_public_path__ + "img/Mask Group 132.387750ef.svg";